<template>
  <div class="pixel-base">
    <page-header :title="title" :subtitle="subtitle" />
    <page-container class="pixel-base">
      <action-dispatcher action="product/get" :parameters="{ limit: 1000 }">
        <bp-select
          v-model="product_id"
          class="mt-5"
          id="product-select"
          label="Nome do produto"
          placeholder="Selecionar produto..."
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <div class="text-center my-9" v-if="loading">
        <b-spinner variant="primary" />
      </div>
      <template v-else-if="product">
        <div class="justify-content-between pt-6">
          <bp-table-header
            v-if="filteredList.length || (!filteredList.length && search_text)"
            :total="filteredList.length"
            @refresh="refresh"
          >
            <template v-slot:buttons>
              <bp-input
                v-model="search_text"
                size="md"
                placeholder="Buscar pela descrição"
                preIcon="fa-light fa-search"
                :delay="300"
                @change="dispatch()"
              />
              <bp-button
                size="md"
                icon="fa-light fa-plus"
                label="Nova integração"
                @click="modal = true"
              />
            </template>
          </bp-table-header>
        </div>

        <div v-if="loading" class="text-center">
          <b-spinner variant="primary" />
        </div>

        <div>
          <bp-data-table
            class="my-3"
            :data="filteredList"
            :columns="columns"
            :noMessage="!filteredList.length && search_text"
          />
          <div
            class="row justify-content-center mt-5"
            v-if="!filteredList.length && search_text"
          >
            <div class="d-flex flex-column">
              <span class="text-neutral-700 fs-16">
                Sua busca não retornou nenhum resultado!
              </span>
            </div>
          </div>
          <div
            class="row justify-content-center mt-5"
            v-else-if="!filteredList.length"
          >
            <div class="d-flex flex-column">
              <span class="text-primary fs-14">
                Você não possui nenhuma conta cadastrada no momento
              </span>
              <span class="d-flex justify-content-center text-primary fs-14">
                Cadastre sua primeira conta para começar
              </span>
              <div class="d-flex justify-content-center mt-5">
                <bp-button
                  @click="modal = true"
                  icon="fa-light fa-plus"
                  label="Nova Integração"
                />
              </div>
            </div>
          </div>
        </div>
        <pixel-modal
          v-if="product && product.pixel"
          v-model="modal"
          :type="pixelType"
          :pixel="editedPixel"
          :customConversionLabel="pixelType === 'google_ads'"
          @submit="submitPixel"
          @submitEdit="submitEditPixel"
        />
      </template>
    </page-container>
  </div>
</template>

<script>
import PixelMixin from "@/mixins/pixel";
import { mapState } from "vuex";
export default {
  mixins: [PixelMixin],
  data() {
    return {
      title: "",
      product_id: null
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    breadcrumbs() {
      return [
        {
          title: "Ferramentas",
          link: "tools"
        },
        { title: this.title }
      ];
    },
    subtitle() {
      return `Integre sua conta do ${this.title} à Blitzpay`;
    },
    pixelList() {
      let list = [];

      if (this.product && this.product.pixel) {
        list = this.product.pixel;
      }

      if (this.search_text) {
        list = list.filter(p =>
          JSON.stringify(p)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .match(this.search_text)
        );
      }

      return [...list.map((item, index) => ({ ...item, index }))];
    },
    filteredList() {
      return this.pixelList.filter(p => p.type === this.pixelType);
    }
  },
  watch: {
    product_id(v) {
      if (v) {
        this.loading = true;
        this.$store.dispatch("product/getProduct", v).finally(() => {
          this.loading = false;
        });
      }
    }
  },
  mounted() {
    this.$store.commit("product/setProduct", null);
  }
};
</script>
